import AnnouncementBar from "@/components/MarketingPage/AnnouncementBar";
import Footer from "@/components/MarketingPage/Footer";
import Header from "@/components/MarketingPage/Header";
import React from "react";
import styled from "styled-components";
import { media } from "@/theme/breakpoints";

const LayoutMain = styled.main`
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  ${media.downMobile`
    padding-left: 0;
    padding-right: 0;
  `}
`;

const Layout = ({ children }) => {
  return (
    <>
      <AnnouncementBar />
      <Header />
      <LayoutMain>{children}</LayoutMain>
      <Footer />
    </>
  );
};

export default Layout;
